import { useState } from "react";
import api, { errMsg } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { KeyRound } from "lucide-react";

const EMPTY = { ancien: "", nouveau: "", confirmation: "" };
const inputCls = "bg-background border-border text-foreground";

export default function ChangePassword({ open, onClose }) {
  const [form, setForm] = useState(EMPTY);
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  const valid = form.ancien && form.nouveau.length >= 6 && form.nouveau === form.confirmation;

  const save = async () => {
    setBusy(true);
    try {
      await api.post("/auth/mot-de-passe", { ancien: form.ancien, nouveau: form.nouveau });
      toast.success("Mot de passe modifié");
      setForm(EMPTY);
      onClose();
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="bg-card border-border text-foreground max-w-sm" data-testid="password-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><KeyRound className="w-4 h-4 text-emerald-600 dark:text-emerald-400" /> Changer mon mot de passe</DialogTitle>
        </DialogHeader>
        <div className="space-y-3 py-2">
          <div className="space-y-1.5">
            <Label className="text-foreground/80">Mot de passe actuel</Label>
            <Input type="password" value={form.ancien} onChange={set("ancien")} data-testid="password-current-input" className={inputCls} />
          </div>
          <div className="space-y-1.5">
            <Label className="text-foreground/80">Nouveau mot de passe (6 caractères min.)</Label>
            <Input type="password" value={form.nouveau} onChange={set("nouveau")} data-testid="password-new-input" className={inputCls} />
          </div>
          <div className="space-y-1.5">
            <Label className="text-foreground/80">Confirmer le nouveau mot de passe</Label>
            <Input type="password" value={form.confirmation} onChange={set("confirmation")} data-testid="password-confirm-input" className={inputCls} />
            {form.confirmation && form.nouveau !== form.confirmation && (
              <p className="text-xs text-red-600 dark:text-red-400" data-testid="password-mismatch">Les mots de passe ne correspondent pas</p>
            )}
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} className="border-border text-foreground/80">Annuler</Button>
          <Button onClick={save} disabled={busy || !valid} data-testid="password-save-button" className="bg-emerald-500 hover:bg-emerald-600 text-white">Enregistrer</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
